import * as swcHelpers from '@swc/helpers';
import { getLocalizedAttrValue, getLocalizedValue, getAttrValue } from '@grandvisionhq/utils';
import { benefits } from '../constants/sorting.js';
import { isBenefit } from '../types/typeguards.js';

const mapVariantToLensPack = (variant, isIncluded, locale)=>{
    var ref, ref1, ref2, ref3, ref4;
    const attributes = variant.attributes || [];
    const visualField = getLocalizedAttrValue(variant, 'visualField', locale);
    const packAttribute = attributes.find((attribute)=>attribute.name === 'pack'
    );
    const packType = (packAttribute === null || packAttribute === void 0 ? void 0 : (ref = packAttribute.value) === null || ref === void 0 ? void 0 : ref.key) || '';
    const packLabel = getLocalizedValue(packAttribute.value, locale);
    const voucher = getAttrValue(variant, 'voucher');
    const voucherValue = (voucher === null || voucher === void 0 ? void 0 : voucher.centAmount) ? Number(voucher === null || voucher === void 0 ? void 0 : voucher.centAmount) : undefined;
    const thickness = getLocalizedAttrValue(variant, 'thickness', locale);
    const lens = (ref1 = attributes.find((attr)=>attr.name === 'lens'
    )) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.key;
    const benefitAttributes = attributes.filter((attribute)=>{
        return benefits.includes(attribute.name);
    }).filter(isBenefit).map((benefit)=>swcHelpers.objectSpread({}, benefit, {
            labelKey: `products.ssp.lenses.${benefit.name}`
        })
    );
    return {
        isIncluded,
        priceInCents: (ref3 = variant.prices) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.value.centAmount,
        sku: variant.sku || '',
        id: variant.id,
        visualField,
        pack: {
            label: packLabel,
            key: packType
        },
        voucherValue,
        thickness,
        benefitAttributes,
        lens
    };
};
const mapProductToLensPacks = (product, isKids, locale)=>{
    const attributes = product.masterVariant.attributes;
    const lensDetails = attributes && attributes.find((attr)=>attr.name === 'lensDetails'
    );
    if (!lensDetails) {
        return {
            monofocalLensPacks: [],
            multifocalLensPacks: []
        };
    }
    const lensPacksData = lensDetails.value.obj.masterData.current;
    const includedLensPack = mapVariantToLensPack(lensPacksData.masterVariant, true, locale);
    const lensPacks = lensPacksData.variants.map((pack)=>mapVariantToLensPack(pack, false, locale)
    );
    const monofocalLensPacks = lensPacks.filter((pack)=>pack.lens === 'singleVision'
    );
    monofocalLensPacks.unshift(includedLensPack);
    let multifocalLensPacks = [];
    if (!isKids) {
        multifocalLensPacks = lensPacks.filter((pack)=>pack.lens === 'multifocal'
        );
    }
    return {
        includedLensPack,
        monofocalLensPacks,
        multifocalLensPacks
    };
};

export { mapProductToLensPacks };
//# sourceMappingURL=map-product-to-lens-packs.js.map
